import React from 'react'
import PropTypes from 'prop-types'
import {
  Button,
  Col,
  FormGroup,
  Input,
  Label,
  Modal,
  ModalBody,
  ModalHeader,
  Row,
} from 'reactstrap'
import * as yup from 'yup'

// @hooks
import { usePregunta } from 'hooks/usePregunta'
import { useCaracteristica } from 'hooks/useCaracteristicas'
import { useGrupoInteres } from 'hooks/useGrupoInteres'
import { useFormik } from 'formik';

const agregarPreguntaSchema = yup.object().shape({
  caracteristica: yup.number().required('Este campo es requerido'),
  grupos_interes: yup.array().min(1, 'Seleccione uno o mas grupos de interes').of(
    yup.string().required('Este campo es requerido'),
  ).required('Este campo es requerido'),
  identificador: yup.string().required('Este campo es requerido'),
  enunciado: yup.string().required('Este campo es requerido'),
})

export const ModalCreditarPregunta = ({ onToggle, open, pregunta, onClosedModal }) => {
  /**
   * Consultas
   */
  const {
    obtenerCaracteristicas,
  } = useCaracteristica()
  const {
    obtenerGruposInteres,
  } = useGrupoInteres()
  const {
    handleCrearPregunta,
    handleActualizarPregunta,
  } = usePregunta(onToggle)
  const { data: caracteristicas } = obtenerCaracteristicas('')
  const { data: gruposInteres } = obtenerGruposInteres('')

  const {
    handleChange,
    values,
    handleSubmit,
    errors,
    isValid, 
    dirty,
  } = useFormik({
    enableReinitialize: true,
    validationSchema: agregarPreguntaSchema,
    initialValues: {
      ...pregunta,
      grupos_interes:
        pregunta.grupos_interes?.map(grupo => grupo.id?.toString()),
    },
    onSubmit: async (values, acciones) => {
      if (pregunta.id) {
        handleActualizarPregunta({ id: pregunta.id, values, acciones})
      } else {
        handleCrearPregunta(values, acciones)
      }
    },
  })
   
  const puedeGuardarPregunta = dirty && isValid
  return (
    <Modal
      isOpen={open}
      toggle={onToggle}
      size='lg'
      unmountOnClose
      onClosed={onClosedModal}
    >
      <ModalHeader toggle={onToggle}>
        {pregunta.id ? 'Editar' : 'Crear'} pregunta
      </ModalHeader>
      <ModalBody>
        <form onSubmit={handleSubmit}>
          <Row>
            <Col md={6}>
              <FormGroup>
                <Label>Característica</Label>
                <Input
                  type='select'
                  name='caracteristica'
                  onChange={handleChange}
                  value={values.caracteristica}
                  placeholder='Ingrese característica'
                  invalid={!!errors.caracteristica}
                >
                  <option value={null}>Selecione...</option>
                  {caracteristicas?.results?.map(caracteristica => (
                    <option key={caracteristica.id} value={caracteristica.id}>
                      {caracteristica.nombre}
                    </option>
                  ))}
                </Input>
                <div className='invalid-feedback'>{errors.caracteristica}</div>
              </FormGroup>
            </Col>
            <Col md={6} style={{ paddingLeft: '2rem' }} >
              <FormGroup>
                <Label>Grupo de interés</Label>
                {gruposInteres?.results?.map(({ id, nombre }) => {
                  const checked = values.grupos_interes?.includes(id.toString())
                  return (
                  <div key={id}>
                    <Input
                      type="checkbox"
                      value={id}
                      checked={checked}
                      name='grupos_interes'
                      onChange={handleChange} 
                      invalid={!!errors.grupos_interes}
                    />
                    <Label check>{nombre}</Label>
                  </div>
                )})}
                {!!errors.grupos_interes && <div
                  style={{
                    width: '100%',
                    marginTop: '0.25rem',
                    fontSize: '80%',
                    color: '#e74a3b'
                }}>
                  {errors.grupos_interes}
                </div>}
              </FormGroup>
            </Col>
          </Row>
          <Row>
            <Col md={6}>
              <FormGroup>
                <Label>Identificador</Label>
                <Input
                  type='text'
                  name='identificador'
                  value={values.identificador}
                  onChange={handleChange}
                  placeholder='Ingrese identificador'
                  invalid={!!errors.identificador}
                />
                <div className='invalid-feedback'>{errors.identificador}</div>
              </FormGroup>
            </Col>
          </Row>

          <Row>
            <Col md={12}>
              <FormGroup>
                <Label>Enunciado</Label>
                <Input
                  type='textarea'
                  name='enunciado'
                  value={values.enunciado}
                  onChange={handleChange}
                  placeholder='Ingrese enunciado'
                  invalid={!!errors.enunciado}
                />
                <div className='invalid-feedback'>{errors.enunciado}</div>
              </FormGroup>
            </Col>
          </Row>
          <div className='invalid-feedback'>{errors.opciones_respuesta}</div>
          <Button
            color='secondary'
            type='submit'
            style={{ marginRight: '10px' }}
            disabled={!puedeGuardarPregunta}
          >
            Guardar y cerrar
          </Button>
          <Button
            color='primary'
            type='submit'
            disabled={!puedeGuardarPregunta}
          >
            Guardar y crear nueva
          </Button>
        </form>
      </ModalBody>
    </Modal>
  )
}

ModalCreditarPregunta.propTypes = {
  onToggle: PropTypes.func.isRequired,
  open: PropTypes.bool.isRequired,
  pregunta: PropTypes.object.isRequired,
  onClosedModal: PropTypes.func.isRequired,
}

ModalCreditarPregunta.defaultProps = {
  pregunta: {}
}
